import React, { useEffect, useState, useRef } from 'react';
import './Empmodalbody.css';
import { Input } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { Checkbox } from 'antd';
import GetImage from '../getimage/Getimage';
import { Modal } from 'react-bootstrap';

export default function Empmodalbody({
  hide,
  managers: initialManagers,
  empids,
  empnames,
  onChange,
  isMultiple,
  heading,
  show
}) {
  console.log(initialManagers,"managers")
  const normalizeDropdownData = (data = []) =>
  Array.isArray(data)
    ? data.map((item) => {
        if (item?.value !== undefined && item?.label !== undefined) {
          return item;
        }

        return {
          value: item.empid ?? item.value ?? 0,
          label:
            item.name ??
            `${item.firstname ?? ""} ${item.lastname ?? ""}`.trim() ??
            item.label ??
            "",
        };
      })
    : [];

const [normalizedManagers, setNormalizedManagers] = useState([]);
const [managers, setManagers] = useState([]);
const ref=useRef()
  const [search, setSearch] = useState('');
  const [showSearch, setShowSearch] = useState(true); 
  const [EmpIDs, setEmpIDs] = useState([]);
  const [selectedMap, setSelectedMap] = useState({});
  const inputRef = useRef(null);

  useEffect(() => {
    if (empids && empnames) {
      const empIDsArray = empids.split(',').map(id => id.trim());
      const initialMap = {};
      empIDsArray.forEach(id => {
        initialMap[id] = true;
      });
      setEmpIDs(empIDsArray);
      setSelectedMap(initialMap);
    }
  }, [empids, empnames]);

  useEffect(() => {
  if (!initialManagers || initialManagers.length === 0) return;

  const normalized = normalizeDropdownData(initialManagers);
  setNormalizedManagers(normalized);
  setManagers(normalized);
}, [initialManagers]);

  useEffect(() => {
    if (showSearch) {
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [showSearch]);

const storeSearch = (e) => {
  const value = e.target.value;
  setSearch(value);

  if (value.trim() === '') {
    setManagers(normalizedManagers);
  } else {
    const filtered = normalizedManagers.filter(emp =>
      emp.label.toLowerCase().includes(value.toLowerCase())
    );
    setManagers(filtered);
  }
};


 
  const toggleEmployee = (emp) => {
    const isSelected = selectedMap[emp.value];
    if (isSelected) {
      setEmpIDs(prev => prev.filter(id => id !== String(emp.value)));
    } else {
      setEmpIDs(prev => [...prev, String(emp.value)]);
    }
    setSelectedMap(prev => ({
      ...prev,
      [emp.value]: !isSelected
    }));
  };

  const selectAll = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allIDs = managers.map(emp => String(emp.value));
      const newMap = {};
      allIDs.forEach(id => {
        newMap[id] = true;
      });
      setEmpIDs(allIDs);
      setSelectedMap(newMap);
    } else {
      setEmpIDs([]);
      setSelectedMap({});
    }
  };

 const onDoneBtnClick = (e) => {
  e.preventDefault();
  const minusOneIds = EmpIDs.filter((id) => id == "-1");
  const otherIds = EmpIDs.filter((id) => id != "-1");
  const orderedIds = [...minusOneIds, ...otherIds];

  const EmpNames = orderedIds.map((id) => {
    const emp = normalizedManagers.find((emp) => String(emp.value) == id);
    return emp ? emp.label.trim() : "";
  });

  onChange(orderedIds, EmpNames);
};

  const handleEmpClick = (emp) => {
    const fullName = (emp.label).trim();
    onChange(String(emp.value), fullName);
  };

  return (
        <Modal
        className='allmodalblur'
        centered
        style={{ backdropFilter:"blur(6px)" }}
        show={show}
        onHide={() => hide()}
      >
        <Modal.Body style={{ padding: "0px 0px", height: "500px" , width:"500px"}}>
  <div className="emp-modal-container">
      <div className="emp-modal-header-search d-flex align-items-center justify-content-between">
        <div>
        <p className="title">Select {heading}</p>
   {isMultiple ? (
    <p style={{  fontSize:"14px",fontWeight: "500", color: "gray" }}>
      {EmpIDs.length} Selected 
    </p>
  ) : null}
        </div>
    
          {isMultiple && (
        <div className="">
          <button className="done-btn" onClick={onDoneBtnClick}>Done</button>
        </div>
      )}
      </div>

      {isMultiple && (
        <div className="selectAll">
          <div style={{flexGrow:"1"}}>
          <Input
          ref={inputRef}
          placeholder='Search'
  allowClear
  autoFocus={true}
  value={search}
  onChange={(e) => storeSearch(e)}
  prefix={<SearchOutlined style={{ color: 'black' }} />}
  style={{ width: '100%', padding:"6px", backgroundColor:"#e6e6e6b3" }}
/>
</div>

<div className='d-flex gap-2 align-items-center'>
  <Checkbox
    onChange={selectAll}
    checked={managers.length > 0 && managers.every(emp => selectedMap[emp.value])}
    style={{ color: "#29b6f6"  }}
  >
   <span style={{fontWeight:"600"}}>Select All</span> 
  </Checkbox>
</div>
        </div>
  
      )}

      <div className="employees-list">
        {managers.map(emp => {
          const empKey = String(emp.value);
          const fullName = (emp.label).trim();
          const isChecked = !!selectedMap[emp.value];

          return (
            <div
              key={empKey}
              className={`employee-row ${isChecked ? "employee-roww":""}`}
              onClick={() => isMultiple ? toggleEmployee(emp) : handleEmpClick(emp)}
            >
              {isMultiple && (
  <Checkbox
    checked={isChecked}
    style={{ marginRight: '8px' }}
  />
)}

              <div className="employee-img">
                <GetImage
                  key={emp.value}
                  redirect={false}
                  width="40px"
                  height="40px"
                  imgID={emp.value}
                />
              </div>
              <div className="employee-name">{fullName}</div>
            </div>
          );
        })}
      </div>
    </div>
        </Modal.Body>
  </Modal>
  );
}
